export default __webpack_public_path__ + "static/media/email-icon.c65cd18e.svg";